import { useContext } from 'react'
import IdentityContext, { Host } from '../context/IdentityContext'

export default function useHost(): Host {
    const { currentHost } = useContext(IdentityContext)
    return currentHost
}
